// src/pages/RegisterPage.js
import React, { useState, useEffect } from 'react';
import { Container, Box, TextField, Button, Typography, Paper, MenuItem, CircularProgress } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios'; // Usamos axios directamente para esta llamada pública
import { apiRegister } from '../services/api';
import { useNotification } from '../context/NotificationContext';

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    station_id: '',
  });
  const [stations, setStations] = useState([]);
  const [loading, setLoading] = useState(false);
  const { showNotification } = useNotification();
  const navigate = useNavigate();

  // Carga la lista de estaciones cuando el componente se monta
  useEffect(() => {
    const fetchStations = async () => {
      try {
        // Esta es una llamada pública, por eso no usamos el apiClient con token
        const response = await axios.get('http://216.119.151.132:4000/api/stations');
        setStations(response.data);
      } catch (error) {
        console.error("Failed to fetch stations", error);
        showNotification('Could not load stations for registration.', 'error');
      }
    };
    fetchStations();
  }, [showNotification]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiRegister(formData);
      showNotification('Registration successful! Please log in.', 'success');
      navigate('/login');
    } catch (error) {
      showNotification(error.response?.data?.message || 'Registration failed.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper elevation={6} sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 4 }}>
        <Typography component="h1" variant="h5">
          Register New Manager
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            margin="normal" required fullWidth name="username" label="Username"
            value={formData.username} onChange={handleChange}
          />
          <TextField
            margin="normal" required fullWidth name="password" label="Password" type="password"
            value={formData.password} onChange={handleChange}
          />
          <TextField
            margin="normal" required fullWidth select name="station_id" label="Station"
            value={formData.station_id} onChange={handleChange}
          >
            {stations.map((station) => (
              <MenuItem key={station.station_id} value={station.station_id}>
                {station.station_name}
              </MenuItem>
            ))}
          </TextField>
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} disabled={loading}>
            {loading ? <CircularProgress size={24} /> : 'Register'}
          </Button>
          <Box textAlign="center">
            <Link href="/login" variant="body2">
              Already have an account? Sign In
            </Link>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default RegisterPage;
